import { render, staticRenderFns } from "./layout-theme-switcher.vue?vue&type=template&id=06e47a46&scoped=true&"
import script from "./layout-theme-switcher.vue?vue&type=script&lang=js&"
export * from "./layout-theme-switcher.vue?vue&type=script&lang=js&"
import style0 from "./layout-theme-switcher.vue?vue&type=style&index=0&id=06e47a46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e47a46",
  null
  
)

export default component.exports